import styled from 'styled-components';
import CopyLinkOutline from '@simplywallst/ui-core/icons/CopyLinkOutline';

export const CopyIcon = styled(CopyLinkOutline)`
  fill: ${({ theme }) => theme.color.mediumGrayRGBA(0.5)};
  cursor: pointer;
  margin-left: ${({ theme }) => theme.x1spacePx}px;
  transform: translate(0px, 6px);

  &:hover {
    fill: ${({ theme }) => theme.color.mediumGray};
  }
`;
